export default __webpack_public_path__ + "files/marker_monitoring_site_up-0126e33b1e78c81c82c73cd3d19a417d.png";